/**
 * Exports
*/

/**
 * 
 */
export function CssClassName(classNames) {
  return Array.isArray(classNames)
    ? classNames.flat().filter(name => name).join(' ')
    : classNames
  ;
}